import moduleRepo from '../services/modules';
import marketingRepo from '../services/marketing';
import marketingListItemTypes from "../services/constants/marketingListItemTypes";

export const MARKETING_MODULES_REFRESHED = 'MARKETING_MODULES_REFRESHED';
export const MARKETING_MODULE_SELECTED   = 'MARKETING_MODULE_SELECTED';
export const UPDATE_MARKETING_SEARCH_RESULTS = 'UPDATE_MARKETING_SEARCH_RESULTS';
export const UPDATE_MARKETING_LIST_ITEMS = 'UPDATE_MARKETING_LIST_ITEMS';
export const ADD_MARKETING_ITEM_TO_LIST = 'ADD_MARKETING_ITEM_TO_LIST';

export function moduleSelected(module) {

    return {
        type: MARKETING_MODULE_SELECTED,
        module
    };
}

export function refreshModules() {

    return (dispatch) => {

        function getSuccess(response) {

            dispatch(modulesRefreshed(response.data.data));
            dispatch(moduleSelected(null));

        }

        moduleRepo.getAllWithCourses()
            .then(getSuccess);
    }
}

export function modulesRefreshed(modules) {

    return {
        type: MARKETING_MODULES_REFRESHED,
        modules
    }
}

function updateSearchResults(searchResults){
    return {
        type: UPDATE_MARKETING_SEARCH_RESULTS,
        searchResults
    }
}

export const getSearchResults = searchTerm => {
    const params = {
        searchTerm: searchTerm
    }

    return dispatch => {
        function getSuccess(response) {
            dispatch(updateSearchResults(response.data.data));
        }

        marketingRepo.getSearchEventsCourses(params)
            .then(getSuccess)
    }
}

function addMarketingItemToList(response){
    return {
        type: ADD_MARKETING_ITEM_TO_LIST,
        response
    }
}

export const addMarketingListItem = selected => {
    if('name' in selected){
        selected = {
            ...selected,
            marketingItemType: marketingListItemTypes.course.id
        }
    }else{
        selected = {
            ...selected,
            marketingItemType: marketingListItemTypes.event.id
        }
    }

    return dispatch => {
        function getSuccess(response){
            dispatch(addMarketingItemToList(response.data.data));
        }

        marketingRepo.addMarketingListItem(selected)
            .then(getSuccess);
    }
}

function updateMarketingListItems(data){
    return {
        type: UPDATE_MARKETING_LIST_ITEMS,
        data
    }
}

export const getMarketingList = () => {
    return dispatch => {
        function getSuccess(response){
            dispatch(updateMarketingListItems(response.data.data)); // something
        }

        marketingRepo.getMarketingListItems()
            .then(getSuccess);
    }
}

export const reOrderMarketingItems = (value, itemID) => {
    const params = {
        id: itemID,
        value: value
    }

    return dispatch => {
        function getSuccess(response){
            dispatch(updateMarketingListItems(response.data.data));
        }

        marketingRepo.reOrderMarketingListItems(params)
            .then(getSuccess);
    }
}

export const removeMarketingItem = id => {
    return dispatch => {
        function getSuccess(response){
            dispatch(updateMarketingListItems(response.data.data));
        }

        marketingRepo.removeMarketingListItem(id)
            .then(getSuccess);
    }
}


// WEBPACK FOOTER //
// ./actions/marketingPage.js